import { render, staticRenderFns } from "./brainLogin.vue?vue&type=template&id=549316a1&scoped=true"
import script from "./brainLogin.vue?vue&type=script&lang=js"
export * from "./brainLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549316a1",
  null
  
)

export default component.exports